export default __webpack_public_path__ + "static/media/4typesCard3.6d185267.png";